import React from "react";
import Button from "../../atoms/Button";
import "./become-a-member-section.m.css";

const BecomeAMemberSection = ({ ...props }) => {
  const { title, description, button } = props.becomeAMember || {};

  return (
    <section styleName="become-a-member-section" {...props}>
      <div styleName="container">
        <div styleName="content">
          <h2 styleName="title">
            {title}
          </h2>

          <p styleName="description">
            {description}
          </p>

          <div styleName="button-wrapper">
            <Button
              href={button?.url}
              variant="memberCta"
            >
              {button?.text}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomeAMemberSection;